"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Landing {
}
exports.default = Landing;
//# sourceMappingURL=Landing.js.map